import { PlatformConfig } from '../../config';

const BASE_URLS = {
    'same-origin': '',
    beehiiv: 'https://api.beehiiv.com/v2',
    'blockworks.co': 'https://blockworks.co',
    coingecko: 'https://api.coingecko.com/api/v3',
    'coingecko-pro': 'https://pro-api.coingecko.com/api/v3',
    'coin-market-cap': 'https://api.coinmarketcap.com/data-api/v3',
    'twelve-data': 'https://api.twelvedata.com',
    'research-api': process.env.API_ENDPOINT ?? process.env.RESEARCH_API_URL,
    'research-api-v2': process.env.RESEARCH_API_URL_V2,
    strapi: PlatformConfig.STRAPI_API_URL,
    'strapi-proxy': '/api/strapi',
    wordpress: 'https://cms.blockworks.co/wp-json',
    mapbox: 'https://api.mapbox.com',
    grip: 'https://api-prod.grip.events/1',
    slack: 'https://slack.com',
    'zoom-auth': 'https://zoom.us',
    'zoom-api': 'https://api.zoom.us/v2',
} as const;

type BaseUrl = keyof typeof BASE_URLS;

export type { BaseUrl };
export { BASE_URLS };
